import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { postBvnUpdate } from "../KycApis";
import Modal from "./index";

const UpdateBVNModal = ({
  showBVNModal,
  setShowBVNModal,
  updateBvn,
  user,
  isProcessing,
}) => {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [bvnData, setBVNData] = useState({ bvnNumber: "" });
  const [validateBvn, setValidateBvn] = useState({ bvnNumberErr: "" });
  const resetDefault = () => {
    setBVNData({ bvnNumber: "" });
    setShowBVNModal(false);
  };

  useEffect(() => {
    Object.values(bvnData).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [bvnData]);

  const validate = () => {
    let bvnNumberErr = "";
    if (isNaN(bvnData.bvnNumber) || bvnData.bvnNumber.length !== 11) {
      bvnNumberErr = "invalid bvn. Should be a string of eleven digits";
    }
    if (bvnNumberErr) {
      setValidateBvn({ bvnNumberErr });
      setBVNData({ bvnNumber: "" });
      return false;
    }
    return true;
  };
  const handleBvnChange = (e) => {
    setBVNData({
      ...bvnData,
      [e.target.id]: e.target.value,
    });
  };

  const handleBVNSubmit = (e) => {
    const isValid = validate();
    if (isValid) {
      try {
        const payload = { bvn: bvnData.bvnNumber };
        postBvnUpdate(payload, user, resetDefault).then((data) => {
          if (data !== undefined) {
            updateBvn(bvnData.bvnNumber);
            toast.success(data.data.message);
            resetDefault();
          }
        });
      } catch (err) {
        toast.error(err);
        resetDefault();
      }
    }
  };

  return (
    <Modal openModal={showBVNModal} setOpenModal={setShowBVNModal}>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        onClick={() => {
          setShowBVNModal(false);
        }}
      ></button>
      <h2 className="fw-bold text-center mb-1" id="updateBVNModal">
        Update BVN
      </h2>
      <div className="card-body">
        <div className="form-group">
          <label className="form-label" htmlFor="bvnNumber">
            Bank Verification Number
          </label>
          <input
            className="form-control"
            id="bvnNumber"
            type="tel"
            pattern="[0-9]{11}"
            onChange={handleBvnChange}
          />
          <small className="text-danger">{validateBvn.bvnNumberErr}</small>
        </div>
        <div className="row">
          <div className="col-12 col-md-auto">
            <button
              className="btn w-100 btn-primary"
              type="submit"
              disabled={!areFieldsSet || isProcessing}
              onClick={handleBVNSubmit}
            >
              {isProcessing ? <>Updating ...</> : <>Update</>}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateBVNModal;
